import { BreakpointsT } from "../types.js"

const breakpoints: BreakpointsT = {
  small: 320,
  medium: 600,
  large: 1080,
  xLarge: 1200,
}

export default breakpoints
